import React from "react";

const SimilarFoodCard = ({ chosenOne, setChosenOne, food }) => {
  return (
    <div
      onClick={() =>
        setChosenOne({
          id: food.id,
          eyemesurementnumber: food.eyemesurementnumber,
          foodName: food.foodname,
        })
      }
      className={
        "flex flex-col gap-1 rounded-[16px] border px-5 py-4 " +
        (chosenOne.id === food.id
          ? "border-main"
          : "border-gray_160")
      }
    >
      <h2 className={
        "text-base font-medium break-words " +
        (chosenOne.id === food.id ? "text-main" : "text-black")
      }>
        {food.foodname}
      </h2>
      <div className="flex gap-1 text-[13px] text-gray_100">
        <span>{food.eyemesurementnumber}</span>
        <span>{food.eyemesurementunit}</span>
      </div>
    </div>
  );
};

export default SimilarFoodCard;
